import React, { createContext, useContext, useMemo, useState } from 'react';

export type BreadcrumbNode = { label: string; to?: string };

type PanelBreadcrumbContextValue = {
  trail: BreadcrumbNode[] | null;
  setTrail: (trail: BreadcrumbNode[] | null) => void;
};

const PanelBreadcrumbContext = createContext<PanelBreadcrumbContextValue | undefined>(undefined);

export const PanelBreadcrumbProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [trail, setTrail] = useState<BreadcrumbNode[] | null>(null);
  const value = useMemo(() => ({ trail, setTrail }), [trail]);

  return (
    <PanelBreadcrumbContext.Provider value={value}>
      {children}
    </PanelBreadcrumbContext.Provider>
  );
};

export function usePanelBreadcrumb(): PanelBreadcrumbContextValue {
  const ctx = useContext(PanelBreadcrumbContext);
  if (!ctx) {
    throw new Error('usePanelBreadcrumb must be used within a PanelBreadcrumbProvider');
  }
  return ctx;
}
